import React from "react";
import { theme, Typography } from "antd";
import { PlatformType } from "../../../../../interfaces/paxTerminal.interface";

const { Text } = Typography;

const COUPLING_OPTIONS: { value: PlatformType; label: string }[] = [
  { value: PlatformType.unitouch, label: "Unitouch" },
  { value: PlatformType.klearly, label: "Klearly" },
  { value: PlatformType.secureRetail, label: "Secure Retail" },
];

interface Props {
  value?: PlatformType;
  onChange: (next: PlatformType) => void;
}

export default function PartnerCouplingStep({ value, onChange }: Props) {
  const { token } = theme.useToken();

  return (
    <div style={{ paddingTop: 4 }}>
      <Text strong style={{ display: "block", marginBottom: 10 }}>
        Coupling Platform <span style={{ color: token.colorError }}>*</span>
      </Text>
      <div
        style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}
      >
        {COUPLING_OPTIONS.map((option) => {
          const selected = option.value === value;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange(option.value)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                textAlign: "left",
                padding: "14px 16px",
                borderRadius: 12,
                cursor: "pointer",
                background: selected
                  ? token.colorPrimaryBg
                  : token.colorBgContainer,
                border: `1px solid ${
                  selected ? token.colorPrimary : token.colorBorder
                }`,
                boxShadow: selected
                  ? `0 0 0 1px ${token.colorPrimary}`
                  : "none",
                transition: "border-color 0.15s, background 0.15s",
              }}
            >
              <span
                style={{
                  flex: "0 0 auto",
                  width: 18,
                  height: 18,
                  borderRadius: "50%",
                  border: `2px solid ${
                    selected ? token.colorPrimary : token.colorBorder
                  }`,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {selected && (
                  <span
                    style={{
                      width: 9,
                      height: 9,
                      borderRadius: "50%",
                      background: token.colorPrimary,
                    }}
                  />
                )}
              </span>
              <Text strong>{option.label}</Text>
            </button>
          );
        })}
      </div>
      <Text
        type="secondary"
        style={{ display: "block", marginTop: 10, fontSize: 13 }}
      >
        Choose which Pax coupling platform the partner will use.
      </Text>
    </div>
  );
}
